export interface IAdminModalComponent {
	data: IAdminModalData<{}>;
	closeEvent: (e?: {}) => void;
}

export interface IAdminModalData<T> {
	type: IAdminModalTypes;
	title?: string;
	description?: string;
	options?: T;
}

export enum IAdminModalTypes {
	deleteOrganization = 'deleteOrganization',
	createOrganization = 'createOrganization',
	updateOrganization = 'updateOrganization',
	customCollectionCycle = 'customCollectionCycle',
	updateOrganizationEmails = 'updateOrganizationEmails',
	recollectOrganization = 'recollectOrganization',
	renameOrganization = 'renameOrganization',
	rawJson = 'rawJson',
	accountPermissions = 'accountPermissions',
	assignOrganization = 'assignOrganization',
	inviteUser = 'inviteUser',
}

export enum IAwsServices {
	AmazonEC2 = 'AmazonEC2',
	AmazonS3 = 'AmazonS3',
	CEReport = 'CEReport',
	AmazonUnusedEBS = 'AmazonUnusedEBS',
	AmazonManagedSnapshots = 'AmazonManagedSnapshots',
	AmazonVolumesWithAgent = 'AmazonVolumesWithAgent',
}
